<template>
    <h3 class="content-headline">{{ menuName }}</h3>
</template>


<script>
export default {
    data() {
        return {
            menuName:'',
        };
    },
    watch: {
        $route(to, from){
            this.menuName = this.$commonUtils.getMenuName(this.menuList)
        }
    },
    mounted() {
        this.menuName = this.$commonUtils.getMenuName(this.menuList)
    }
}
</script>
